import { getToolTypeLabel, NuggetBadge, type ToolType } from '@backrs_ui/common-ui';

import { Box, SxProps, Theme } from '@mui/material';

type BannerTypeChipProps = Readonly<{
  toolType: ToolType;
}>;

/** Tool-type chip pinned to a banner's bottom-left corner. */
export const BannerTypeChip: React.FC<BannerTypeChipProps> = ({ toolType }) => (
  <Box sx={chipSx}>
    <NuggetBadge label={getToolTypeLabel(toolType)} iconConfig={{ mode: 'backrsLogo' }} />
  </Box>
);

const chipSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'absolute',
  bottom: backrs.spacing['spacing-lg'],
  left: backrs.spacing['spacing-lg'],
  pointerEvents: 'none',
  '@container (max-width: 599px)': {
    bottom: backrs.spacing['spacing-sm'],
    left: backrs.spacing['spacing-sm'],
  },
});
